<template>
    <div class="container-fluid mt-5">
      <div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <template slot="header">
            <div class="row">
              <div class="col-6">
                <h3 class="mb-0">Descuentos</h3>
              </div>
              <div class="col-6 text-right">
                <base-button class="hover-apolo" type="default" icon size="sm" @click="showAddModal = true">
                  <span class="btn-inner--icon"
                    ><i class="fas fa-plus"></i
                  ></span>
                  <span class="btn-inner--text">Descuento</span>
                </base-button>
              </div>
            </div>
          </template>
          <div
            class="col-12 mb-3 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <el-select
              class="select-primary pagination-select"
              v-model="pagination.perPage"
              placeholder="Datos por página"
            >
              <el-option
                class="select-primary"
                v-for="item in pagination.perPageOptions"
                :key="item.value"
                :label="item.descripcion"
                :value="Number(item.value)"
              >
              </el-option>
            </el-select>
          </div>
            <el-table
              class="table-responsive align-items-center table-flush"
              header-row-class-name="thead-light"
              :data="descuentos"
              @sort-change="sortChange"
            >
              <div slot="empty" v-if="loading">
                <img src="/img/loading.gif" style="height: 100px; width: 100px" />
              </div>

              <div slot="empty" v-if="descuentos">
                Sin datos disponibles
              </div>
              <el-table-column label="Tipo Descuento" prop="attributes.tipo_descuento" />
              <el-table-column label="Nombre" prop="attributes.nombre" />
              <el-table-column label="Tipo Valor" prop="attributes.tipo_valor" />
              <el-table-column label="Valor" prop="attributes.valor" />
              <el-table-column label="Cantidad Máxima" prop="attributes.cantidad_maxima" />
              <el-table-column label="Fecha Inicio">
                <div slot-scope="{ row }">
                  <span v-if="row.attributes.fecha_inicio">{{row.attributes.fecha_inicio | moment('DD-MM-YYYY')}}</span>
                  <span v-else>Sin Fecha</span>
                </div>
              </el-table-column>
              <el-table-column label="Fecha Fin">
                <div slot-scope="{ row }">
                  <span v-if="row.attributes.fecha_fin">{{row.attributes.fecha_fin | moment('DD-MM-YYYY')}}</span>
                  <span v-else>Sin Fecha</span>
                </div>
              </el-table-column>
              <el-table-column align="center">
                <div slot-scope="{ row }" class="table-actions">
                  <base-button class="hover-apolo" type="primary" icon size="sm" @click="editDescuento(row)">
                    <span class="btn-inner--text">Editar</span>
                  </base-button>
                  <base-button v-if="row.attributes.active" class="hover-apolo" type="primary" icon size="sm" @click="deactivateDescuento(row)">
                    <span class="btn-inner--text">Desactivar</span>
                  </base-button>
                  <base-button  v-else class="hover-apolo" type="primary" icon size="sm" @click="activateDescuento(row)">
                    <span class="btn-inner--text">Activar</span>
                  </base-button>
                </div>
              </el-table-column>
            </el-table>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center flex-wrap"
          >
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            />
          </div>
        </card>
      </div>
      <!-- MODAL CREATE -->
      <modal :show.sync="showAddModal" modal-classes="modal-primary">
        <h6 slot="header" class="mb-0 modal-title">Crear descuento</h6>
        <form class="new-event--form" @submit.prevent="addDescuento">
          <base-input label="Nombre"
                      placeholder="Nombre del descuento"
                      v-model="descuento.nombre"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <validation-error :errors="apiValidationErrors.nombre" />
          <base-input label="Tipo de descuento">
            <el-select
                class="select-primary"
                v-model="descuento.tipo_descuento"
                placeholder="Seleccionar tipo de descuento"
              >
                <el-option
                  class="select-primary"
                  v-for="item in tipoDescuentos"
                  :key="item.value"
                  :label="item.nombre"
                  :value="Number(item.value)"
                >
                </el-option>
            </el-select>
          </base-input>
          <validation-error :errors="apiValidationErrors.tipo_descuento" />
          <base-input label="Tipo de Valor">
            <el-select
                class="select-primary"
                v-model="descuento.tipo_valor"
                placeholder="Seleccionar tipo de valor"
              >
                <el-option
                  class="select-primary"
                  v-for="item in tipoValores"
                  :key="item.value"
                  :label="item.nombre"
                  :value="Number(item.value)"
                >
                </el-option>
            </el-select>
          </base-input>
          <validation-error :errors="apiValidationErrors.tipo_valor" />
          <base-input label="Valor"
                      placeholder="Valor"
                      v-model="descuento.valor"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <validation-error :errors="apiValidationErrors.valor" />
          <base-input label="Cantidad Máxima"
                      placeholder="Cantidad Máxima"
                      v-model="descuento.cantidad_maxima"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <validation-error :errors="apiValidationErrors.cantidad_maxima" />
          <base-input label="Es descuento permanente?">
            <base-switch v-model="descuento.es_permanente" class="mr-1"></base-switch>
          </base-input>
          <div v-if="descuento.es_permanente === false" >
            <base-input label="Fecha de Inicio">
              <date-picker
                v-model="descuento.fecha_inicio"
                :format="'DD-MM-YYYY'"
                :lang="'es'"
              ></date-picker>
            </base-input>
            <validation-error :errors="apiValidationErrors.fecha_inicio" />
            <base-input label="Fecha de Fin">
              <date-picker
                v-model="descuento.fecha_fin"
                :format="'DD-MM-YYYY'"
                :lang="'es'"
              ></date-picker>
            </base-input>
            <validation-error :errors="apiValidationErrors.fecha_fin" />
          </div>
          <br>
          <span>Opcionales:</span>
          <base-input label="Mensaje en taquilla"
                      placeholder="Mensaje en taquilla"
                      v-model="descuento.mensaje_taquilla"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <validation-error :errors="apiValidationErrors.mensaje_taquilla" />
          <base-input label="Mensaje en pantalla a pasajero en venta en linea"
                      placeholder="Mensaje en pantalla a pasajero en venta en linea"
                      v-model="descuento.mensaje_pantalla"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <validation-error :errors="apiValidationErrors.mensaje_pantalla" />
          <base-input label="Mensaje en correo a pasajero en venta en linea"
                      placeholder="Mensaje en correo a pasajero en venta en linea"
                      v-model="descuento.mensaje_correo"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <validation-error :errors="apiValidationErrors.mensaje_correo" />
          <input type="hidden" class="new-event--start"/>
          <input type="hidden" class="new-event--end"/>
        </form>

        <template slot="footer">
          <button type="submit" class="btn btn-default hover-apolo new-event--add" @click="addDescuento">Guardar</button>
          <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="closeModal">Cerrar</button>
        </template>
      </modal>
      <!-- MODAL EDIT -->
      <modal :show.sync="showEditModal" modal-classes="modal-primary">
        <h6 slot="header" class="mb-0 modal-title">Editar Descuento</h6>
        <form class="new-event--form" @submit.prevent="updateDescuento">
          <base-input label="Nombre"
                      placeholder="Nombre del descuento"
                      v-model="descuento.nombre"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <validation-error :errors="apiValidationErrors.nombre" />
          <base-input label="Tipo de descuento">
            <el-select
                class="select-primary"
                v-model="descuento.tipo_descuento"
                placeholder="Seleccionar tipo de descuento"
              >
                <el-option
                  class="select-primary"
                  v-for="item in tipoDescuentos"
                  :key="item.value"
                  :label="item.nombre"
                  :value="Number(item.value)"
                >
                </el-option>
            </el-select>
          </base-input>
          <validation-error :errors="apiValidationErrors.tipo_descuento" />
          <base-input label="Tipo de Valor">
            <el-select
                class="select-primary"
                v-model="descuento.tipo_valor"
                placeholder="Seleccionar tipo de valor"
              >
                <el-option
                  class="select-primary"
                  v-for="item in tipoValores"
                  :key="item.value"
                  :label="item.nombre"
                  :value="Number(item.value)"
                >
                </el-option>
            </el-select>
          </base-input>
          <validation-error :errors="apiValidationErrors.tipo_valor" />
          <base-input label="Valor"
                      placeholder="Valor"
                      v-model="descuento.valor"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <validation-error :errors="apiValidationErrors.valor" />
          <base-input label="Cantidad Máxima"
                      placeholder="Cantidad Máxima"
                      v-model="descuento.cantidad_maxima"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <validation-error :errors="apiValidationErrors.cantidad_maxima" />
          <base-input label="Es descuento permanente?">
            <base-switch v-model="descuento.es_permanente" class="mr-1"></base-switch>
          </base-input>
          <div v-if="descuento.es_permanente === false" >
            <base-input label="Fecha de Inicio">
              <date-picker
                v-model="descuento.fecha_inicio"
                :format="'DD-MM-YYYY'"
                :lang="'es'"
              ></date-picker>
            </base-input>
            <validation-error :errors="apiValidationErrors.fecha_inicio" />
            <base-input label="Fecha de Fin">
              <date-picker
                v-model="descuento.fecha_fin"
                :format="'DD-MM-YYYY'"
                :lang="'es'"
              ></date-picker>
            </base-input>
            <validation-error :errors="apiValidationErrors.fecha_fin" />
          </div>
          <br>
          <span>Opcionales:</span>
          <base-input label="Mensaje en taquilla"
                      placeholder="Mensaje en taquilla"
                      v-model="descuento.mensaje_taquilla"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <validation-error :errors="apiValidationErrors.mensaje_taquilla" />
          <base-input label="Mensaje en pantalla a pasajero en venta en linea"
                      placeholder="Mensaje en pantalla a pasajero en venta en linea"
                      v-model="descuento.mensaje_pantalla"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <validation-error :errors="apiValidationErrors.mensaje_pantalla" />
          <base-input label="Mensaje en correo a pasajero en venta en linea"
                      placeholder="Mensaje en correo a pasajero en venta en linea"
                      v-model="descuento.mensaje_correo"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <validation-error :errors="apiValidationErrors.mensaje_correo" />
          <input type="hidden" class="new-event--start"/>
          <input type="hidden" class="new-event--end"/>
        </form>

        <template slot="footer">
          <button type="submit" class="btn btn-default hover-apolo new-event--add" @click="updateDescuento">Actualizar</button>
          <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="closeModal">Cerrar</button>
        </template>
      </modal>
    </div>
  </template>
  <script>
  import formMixin from "@/mixins/form-mixin";
  import ValidationError from "@/components/ValidationError.vue";
  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';
  import { BasePagination, Modal } from "@/components/";
  import {
    Table,
    TableColumn,
    DropdownMenu,
    DropdownItem,
    Dropdown,
    Tooltip,
    Select,
    Option,
    RadioButton,
    Button,
  } from "element-ui";
  import swal from "sweetalert2";
  import "sweetalert2/dist/sweetalert2.css";
  
  export default {
    layout: "DashboardLayout",
  
    components: {
      Modal,
      DatePicker,
      ValidationError,
      BasePagination,
      [Tooltip.name]: Tooltip,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
      [Select.name]: Select,
      [Option.name]: Option,
      [Button.name]: Button,
    },

    mixins: [formMixin],
  
    data() {
      return {
        descuentos: [],
        selectedRows: [],
  
        sort: "created_at",
  
        pagination: {
          perPage: 5,
          currentPage: 1,
          perPageOptions: [{value:'5', descripcion: '5 descuentos por página'},
          {value:'10', descripcion: '10 descuentos por página'},
          {value:'25', descripcion: '25 descuentos por página'},
          {value:'50', descripcion: '50 descuentos por página'}],
        },
        tipoDescuentos: [{value:'1', nombre:'General (Venta en taquilla sin aprobación)'},
                         {value:'2', nombre:'Especial (Venta en taquilla con aprobación)'},
                         {value:'3', nombre:'En linea (Venta directa a pasajeros en linea)'}],
        tipoValores: [{value:'1', nombre:'Monto Fijo'},
                      {value:'2', nombre:'Porcentaje'}],
        total: 0,
        loading: true,
        showAddModal: false,
        showEditModal: false,
        descuento: {
          type: "descuento",
          nombre: null,
          tipo_descuento: null,
          tipo_valor: null,
          valor: null,
          cantidad_maxima: null,
          es_permanente: true,
          fecha_inicio: null,
          fecha_fin: null,
          mensaje_taquilla: null,
          mensaje_pantalla: null,
          mensaje_correo: null,
        }
      };
    },
  
    computed: {
      from() {
        return this.pagination.perPage * (this.pagination.currentPage - 1);
      },
  
      to() {
        let highBound = this.from + this.pagination.perPage;
        if (this.total < highBound) {
          highBound = this.total;
        }
        return highBound;
      },
    },
  
    watch: {
      search: {
        handler: "getListDebounced",
        immediate: true,
      },
      pagination: {
        handler: "getList",
        immediate: false,
        deep: true,
      },
    },

    mounted(){
      //const date = new Date();
      //this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
    },
    
    methods: {
      getListDebounced: _.debounce(function () {
        this.getList();
      }, 300),
  
      async getList() {
        let params = {
          ...(this.sort ? { sort: this.sort } : {}),
          page: {
            number: this.pagination.currentPage,
            size: this.pagination.perPage,
          },
        };
        await this.$store.dispatch("descuentos/list", params).then(() => {
          this.descuentos = this.$store.getters["descuentos/list"];
          this.total = this.$store.getters["descuentos/listTotal"];
        });
        this.loading = false;
      },

      closeModal() {
        if(this.showAddModal == true){
          this.showAddModal = false;
        }else{
          this.showEditModal = false;
        }
        this.resetApiValidation();
        this.descuento.nombre = null;
        this.descuento.tipo_descuento = null;
        this.descuento.tipo_valor = null;
        this.descuento.valor = null;
        this.descuento.cantidad_maxima = null;
        this.descuento.es_permanente = true;
        this.descuento.fecha_inicio = null;
        this.descuento.fecha_fin = null;
        this.descuento.mensaje_taquilla = null;
        this.descuento.mensaje_pantalla = null;
        this.descuento.mensaje_correo = null;
      },

      async addDescuento(){
        try {
        await this.$store.dispatch("descuentos/add", this.descuento);
        this.$notify({
          type: "success",
          message: "Descuento creado satisfactoriamente.",
          duration: -1
        });
        this.getList();
        this.closeModal();
        } catch (error) {
          if (error.response.data.errors[0]) {
              this.$notify({
                  type: "danger",
                  message: error.response.data.errors[0].detail,
                  duration: -1
              });
          } else {
              this.$notify({
                  type: "danger",
                  message: "Oops, ha ocurrido un problema!",
                  duration: -1
              });
          }
          this.resetApiValidation();
          this.setApiValidation(error.response.data.errors);
        }
      },

      editDescuento(row) {
        this.resetApiValidation();
        this.showEditModal = true;
        this.descuento.nombre = row.attributes.nombre;
        this.descuento.tipo_descuento = row.attributes.tipo_descuento;
        if(row.attributes.tipo_valor === "$"){
          this.descuento.tipo_valor = 'Monto Fijo';
        }else{
          this.descuento.tipo_valor = 'Porcentaje';
        }
        this.descuento.valor = row.attributes.valor;
        this.descuento.cantidad_maxima = row.attributes.cantidad_maxima;
        if(row.attributes.es_permanente === 0){
          this.descuento.es_permanente = false;
        }else{
          this.descuento.es_permanente = true;
        }
        this.descuento.mensaje_taquilla = row.attributes.mensaje_taquilla;
        this.descuento.mensaje_pantalla = row.attributes.mensaje_pantalla;
        this.descuento.mensaje_correo = row.attributes.mensaje_correo;
        if(row.attributes.fecha_inicio){
          const dateInicio = row.attributes.fecha_inicio.split('-');
          this.descuento.fecha_inicio = new Date(dateInicio[0],dateInicio[1]-1,dateInicio[2]);
        }
        if(row.attributes.fecha_fin){
          const dateFin = row.attributes.fecha_fin.split('-');
          this.descuento.fecha_fin = new Date(dateFin[0],dateFin[1]-1,dateFin[2]);
        }
        this.descuento.id = row.id;
      },

      async updateDescuento() {
        console.log(this.descuento.es_permanente)
        if(this.descuento.tipo_valor === 'Monto Fijo'){
          this.descuento.tipo_valor = 1;
        }
        if(this.descuento.tipo_valor === 'Porcentaje'){
          this.descuento.tipo_valor = 2;
        }
        if(this.descuento.tipo_descuento === 'General'){
          this.descuento.tipo_descuento = 1;
        }
        if(this.descuento.tipo_descuento === 'Especial'){
          this.descuento.tipo_descuento = 2;
        }
        if(this.descuento.tipo_descuento === 'En Línea'){
          this.descuento.tipo_descuento = 3;
        }
        if(this.descuento.es_permanente === true){
          this.descuento.fecha_inicio = null;
          this.descuento.fecha_fin = null;
        }  
        try{
          await this.$store.dispatch("descuentos/update", this.descuento);
          this.$notify({
            type: "success",
            message: "Descuento actualizado satisfactoriamente.",
            duration: -1
          });
          this.getList();
          this.closeModal();
        } catch (error) {
          if (error.response.data.errors[0]) {
              this.$notify({
                  type: "danger",
                  message: error.response.data.errors[0].detail,
                  duration: -1
              });
          } else {
              this.$notify({
                  type: "danger",
                  message: "Oops, ha ocurrido un problema!",
                  duration: -1
              });
          }
          this.resetApiValidation();
          this.setApiValidation(error.response.data.errors);
        }
      },
      
      async activateDescuento(row) {
        const confirmation = await swal.fire({
          title: `¿Desea activar este descuento?`,
          type: "question",
          buttonsStyling: false,
          showCancelButton: true,
          confirmButtonText: "Activar",
          cancelButtonText: "Cancelar",
          confirmButtonClass: "btn btn-lg btn-default hover-apolo",
          cancelButtonClass: "btn btn-lg btn-secondary hover-apolo",
        });
  
        try {
          if (confirmation.value === true) {
              await this.$store.dispatch("descuentos/activate", row.id);
              await this.getList();
              this.$notify({
              type: "success",
              message: "Descuento activado satisfactoriamente.",
              duration: -1
            });
          }
        } catch (error) {
          if (error.response.data.errors[0]) {
              this.$notify({
                  type: "danger",
                  message: error.response.data.errors[0].detail,
                  duration: -1
              });
          } else {
              this.$notify({
                  type: "danger",
                  message: "Oops, ha ocurrido un problema!",
                  duration: -1
              });
          }
        }
      },
      async deactivateDescuento(row) {
        const confirmation = await swal.fire({
          title: `¿Desea desactivar este descuento?`,
          type: "question",
          buttonsStyling: false,
          showCancelButton: true,
          confirmButtonText: "Desactivar",
          cancelButtonText: "Cancelar",
          confirmButtonClass: "btn btn-lg btn-default hover-apolo",
          cancelButtonClass: "btn btn-lg btn-secondary hover-apolo",
        });
  
        try {
          if (confirmation.value === true) {
              await this.$store.dispatch("descuentos/deactivate", row.id);
              await this.getList();
              this.$notify({
              type: "success",
              message: "Descuento desactivado satisfactoriamente.",
              duration: -1
            });
          }
        } catch (error) {
          if (error.response.data.errors[0]) {
              this.$notify({
                  type: "danger",
                  message: error.response.data.errors[0].detail,
                  duration: -1
              });
          } else {
              this.$notify({
                  type: "danger",
                  message: "Oops, ha ocurrido un problema!",
                  duration: -1
              });
          }
        }
      },

      sortChange({ prop, order }) {
        if (order === "descending") {
          this.sort = `-${prop}`;
        } else {
          this.sort = `${prop}`;
        }
        this.getList();
      },
    },
  };
  </script>